export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usuário não encontrado"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecionar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fechar"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pesquisa"])}
}